import React, { useState } from 'react';

const Application = () => {
  const [showScholarship, setShowScholarship] = useState(false);
  const [showEnrollment, setShowEnrollment] = useState(false);

  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <form action="controller.php?action=application" method="post">
          <fieldset className="mb-6">
            <legend className="text-2xl font-bold mb-4">Student Application</legend>
            <div className="mb-4">
              <label htmlFor="name" className="block font-bold mb-2">Name</label>
              <input id="name" name="name" type="text" size="50" className="w-full border border-gray-300 rounded p-2" />
            </div>
            <div className="mb-4">
              <label htmlFor="address1" className="block font-bold mb-2">Address 1</label>
              <input id="address1" type="text" size="50" className="w-full border border-gray-300 rounded p-2" />
            </div>
            <div className="mb-4">
              <label htmlFor="address2" className="block font-bold mb-2">Address 2</label>
              <input id="address2" type="text" size="50" className="w-full border border-gray-300 rounded p-2" />
            </div>
            <div className="mb-4">
              <label htmlFor="city" className="block font-bold mb-2">City</label>
              <input id="city" type="text" name="city" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="state" className="block font-bold mb-2">State/Province</label>
              <input id="state" type="text" name="state" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="zip" className="block font-bold mb-2">Zip Code</label>
              <input id="zip" type="text" name="zip" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="country" className="block font-bold mb-2">Country</label>
              <input id="country" type="text" name="country" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="email" className="block font-bold mb-2">E-Mail</label>
              <input id="email" type="text" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="phone" className="block font-bold mb-2">Home Phone</label>
              <input id="phone" type="text" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="work_phone" className="block font-bold mb-2">Work Phone</label>
              <input id="work_phone" type="text" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="date" className="block font-bold mb-2">Date</label>
              <input id="date" type="text" name="date" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="marital_status" className="block font-bold mb-2">Marital Status</label>
              <select id="marital_status" className="w-full border border-gray-300 rounded p-2">
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Divorce">Divorce</option>
              </select>
            </div>
          </fieldset>

          <fieldset className="mb-6">
            <legend className="text-2xl font-bold mb-4">Program Information</legend>
            <div className="mb-4">
              <label htmlFor="degree_seeking" className="block font-bold mb-2">Degree desired</label>
              <select id="degree_seeking" className="w-full border border-gray-300 rounded p-2">
                <option value="bachelors_science">Bachelors of Science</option>
                <option value="masters_science">Masters of Science</option>
                <option value="dr_ministry">Doctorate of Ministry</option>
                <option value="ma_business_admin">Masters in Business Admin</option>
                <option value="dr_business_admin">Doctorate in Business Admin</option>
                <option value="phd">Ph.D</option>
                <option value="as_arts">Associate in Arts</option>
                <option value="certificate_programs">Certificate Programs</option>
              </select>
            </div>
          </fieldset>

          <fieldset className="mb-6">
            <legend className="text-2xl font-bold mb-4">Previous Education</legend>
            <div className="mb-4">
              <label htmlFor="institution_name" className="block font-bold mb-2">Name of Institution</label>
              <input id="institution_name" type="text" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="year_graduated" className="block font-bold mb-2">Year Graduated</label>
              <input id="year_graduated" type="text" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="degree" className="block font-bold mb-2">Degree</label>
              <input id="degree" type="text" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="major" className="block font-bold mb-2">Major</label>
              <input id="major" type="text" name="major" className="w-full border border-gray-300 rounded p-2" size="12" />
            </div>
            <div className="mb-4">
              <label htmlFor="gpa" className="block font-bold mb-2">GPA</label>
              <input id="gpa" type="text" name="gpa" className="w-full border border-gray-300 rounded p-2" size="12" />
            </div>
            {/* Repeat for additional institutions */}
          </fieldset>

          <fieldset className="mb-6">
            <legend className="text-2xl font-bold mb-4">Employment History</legend>
            <p className="mb-4">*please list the last 10 years of employment</p>
            <div className="mb-4">
              <label htmlFor="employment_type" className="block font-bold mb-2">Type of Employment</label>
              <input id="employment_type" type="text" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="employment_date" className="block font-bold mb-2">Date</label>
              <input id="employment_date" type="text" name="employment_date" className="w-full border border-gray-300 rounded p-2" size="12" />
            </div>
            <div className="mb-4">
              <label htmlFor="employer" className="block font-bold mb-2">Employer</label>
              <input id="employer" type="text" name="employer" className="w-full border border-gray-300 rounded p-2" size="12" />
            </div>
            {/* Repeat for additional employment history */}
          </fieldset>

          <fieldset className="mb-6">
            <legend className="text-2xl font-bold mb-4">References</legend>
            <div className="mb-4">
              <label htmlFor="reference_name" className="block font-bold mb-2">Name</label>
              <input id="reference_name" type="text" className="w-full border border-gray-300 rounded p-2" size="50" />
            </div>
            <div className="mb-4">
              <label htmlFor="reference_email" className="block font-bold mb-2">Email Address</label>
              <input id="reference_email" type="text" name="reference_email" className="w-full border border-gray-300 rounded p-2" size="12" />
            </div>
            <div className="mb-4">
              <label htmlFor="reference_phone" className="block font-bold mb-2">Phone</label>
              <input id="reference_phone" type="text" name="reference_phone" className="w-full border border-gray-300 rounded p-2" size="12" />
            </div>
            {/* Repeat for additional references */}
          </fieldset>

          <p className="mb-4"><a href="mailto:info@hcbahamas.com" className="text-blue-500 underline">Attach (by email)</a> a copy of one legal document (drivers license, birth certificate, social security card, or passport front page)</p>
          <p className="mb-4"><a href="mailto:info@hcbahamas.com" className="text-blue-500 underline">Attach (by email)</a> copies of your transcripts - unofficial is fine - official transcript will be required for official records</p>
          <p className="mb-4"><a href="mailto:info@hcbahamas.com" className="text-blue-500 underline">Attach (by email)</a> copies of your certificate of completion and diploma</p>

          <p className="mb-4">Will you be applying for a scholarship?<br />
            <a href="#scholarship" onClick={() => setShowScholarship(true)} className="text-blue-500 underline">Yes</a>&nbsp;&nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;&nbsp;
            <a href="#scholarship" onClick={() => setShowScholarship(false)} className="text-blue-500 underline">No</a>
          </p>
          <span id="scholarship"></span>
          {showScholarship && (
            <div id="scholarship" className="mb-6">
              <p className="mb-4">
                <input type="checkbox" name="scholarship-opt-in" className="mr-2" />
                I have read and understand the conditions of the Vaidya Scholarship as explained in the current Notes to Candidates for Scholarships on the HCB website. I affirm that I plan to pursue a professorial career in business. I give permission to officials of my institution to release transcripts of my academic record and other information requested for consideration in the HCB Scholarship program. I understand that this application will be available only to qualified people who need to see it in the course of their duties. I waive the right to access letters of recommendation written on my behalf. If selected as a Vaidya Scholar, I will attend HCB. I affirm that all of this application, including the policy proposal, is my own work or formally cited from other sources. I affirm the information contained herein is true and accurate to the best of my knowledge and belief.
              </p>
              <p className="mb-4">
                I am a
                <select id="nationality" className="ml-2 border border-gray-300 rounded p-2">
                  <option value="citizen">U.S. citizen</option>
                  <option value="national">U.S. national</option>
                  <option value="other">Other</option>
                </select>
              </p>
              <p className="mb-4">In what country will you be studying? <input id="country_study" type="text" size="20" className="border border-gray-300 rounded p-2" /></p>
              <p className="mb-4">Name of nominating person <input id="name_nomimator" type="text" size="20" className="border border-gray-300 rounded p-2" /></p>
              <p className="mb-4">Expected date to receive baccalaureate degree <input id="expected_grad_date" type="text" size="20" className="border border-gray-300 rounded p-2" /></p>
              <p className="mb-4">If you have more activities, work experience, and/or awards than the space allows, list only those you consider most significant.</p>
              <textarea cols="500" rows="5" name="additional_scholarship_info" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">List college and high school activities (student government, sports, publications, school-sponsored community service programs, student-faculty committees, arts, music, etc.). List in descending order of significance.</p>
              <textarea cols="500" rows="5" name="extra_cirr" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">List public service and community activities (homeless services, environmental protection/conservation, advocacy activities, work with religious organizations, etc.). Do not repeat items listed previously. List in descending order of significance.</p>
              <textarea cols="500" rows="5" name="comm_service" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">List government activities (internships with government agencies, partisan political activities, ROTC/military, municipal boards and commissions).</p>
              <textarea cols="500" rows="5" name="govt_service" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">List awards, scholarships, publications or special recognitions you have received. List in descending order of significance.</p>
              <textarea cols="500" rows="5" name="awards" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">Describe one specific example of your leadership. (The writer of your letter of recommendation re: Leadership Abilities and Potential must confirm this experience.) Limit 700 characters including spaces.</p>
              <textarea cols="500" rows="5" name="leadership" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">Describe a recent particularly satisfying public service activity (do not repeat experience described above). Limit 700 characters including spaces.</p>
              <textarea cols="500" rows="5" name="public_service" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">Describe why you think you deserve a scholarship aside from financial need. Limit 500 characters including spaces.</p>
              <textarea cols="500" rows="5" name="deserve_scholar" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">If selected as a Scholar, would you apply for additional studies in the future? If yes, where would you like to attend and possibly work and what issues would you like to address? If no, what are your plans after you graduate?</p>
              <textarea cols="500" rows="5" name="significant_courses" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">Describe the graduate education program you intend to pursue if you receive a Vaidya Scholarship.</p>
              <textarea cols="500" rows="5" name="ed_program" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">What do you hope to do and what position do you hope to have upon completing your graduate studies? Limit 900 characters including spaces.</p>
              <textarea cols="500" rows="5" name="career_question" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">What do you hope to do and what position do you hope to have five to seven years later? Limit 900 characters including spaces.</p>
              <textarea cols="500" rows="5" name="five_year_plan" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
              <p className="mb-4">What additional personal information do you wish to share with the scholarship committee? Limit 2000 characters including spaces.</p>
              <textarea cols="500" rows="5" name="addtional_scholarship" className="w-full border border-gray-300 rounded p-2 mb-4"></textarea>
            </div>
          )}

          <p className="mb-4">Do you want to be considered for credit by portfolio or experience learning credits?<br />
            <a href="#enrollment" onClick={() => setShowEnrollment(true)} className="text-blue-500 underline">Yes</a>&nbsp;&nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;&nbsp;
            <a href="#enrollment" onClick={() => setShowEnrollment(false)} className="text-blue-500 underline">No</a>
          </p>
      <div id="enrollment"></div>
      <div id="enrollment" style={{ display: 'none' }}>
				<ul class="niceList">
				<li>Complete the Application for Credit form, noting the course description(s) from the course description
				list for the course(s) for which you are seeking credit. All of the materials gathered for the portfolio should
				demonstrate your knowledge of the various elements of the course description(s). The materials gathered must
				reflect your personal experience and be prepared by you.</li>
				
				<li>The resume form should give the evaluator an outline of your background and a summary overview of your
				experience. Make it as complete as possible so the evaluator can have a good understanding of who you are and
				what you have done.</li>
				
				<li>If the Admissions and Registrar Department does not have a complete file of your transcripts, include them
				in your portfolio. It is important that the evaluator be able to see all of the academic work you have done which
				may relate to the credit being sought.</li>
				
				<li>List the courses, workshops and seminars you have attended which relate directly to the course(s) for which
				credit is being sought. Do not list unrelated events. Describe the nature of the subjects discussed, the length of
				the sessions and any other information which will fully explain the nature of the event. Attach documentation of
				your attendance (programs, attendance certificates, CEU certifications, brochures, etc.).</li>
				
				<li>In the bibliography list any books which you have read and which directly relate to the course. Do not list
				books you have in your library that you have not read.</li>
				
				<li>Send two copies of the completed portfolio to the Dean of your school/college and the Admissions and
				Registrar Department at the address listed on the front page. You will be sent an updated transcript based on the
				evaluation of your portfolio.</li>
				</ul>
				<ul  class="niceList">
				<li>ACADEMIC REQUIREMENTS: Academic Requirements of Hamilton College of the Bahamas are listed in
				the catalogue or under the requirements for degrees.</li>
				
				<li>RESUME: The resume provides an outline of personal, educational, military, employment and ministerial
				background. Consider it to be an introduction to the portfolio which will be used as a reference by the
				evaluator when reviewing the other sections. Attach your resume as Attachment A of this portfolio package.</li>
				
				<li>TRANSCRIPTS: If the Admissions and Registrar do not have a complete file or transcripts of your
				academic work, attach them to the portfolio package as Attachment B.</li>
				
				<li>PROFESSIONAL COURSES/WORKSHOPS/SEMINARS: List those courses, workshops, and/or seminars
				in which you have participated and which relate to the course for which you are seeking credit. Attach
				documentation of your attendance to the portfolio package as Attachment C.</li>
				
				<li>BIBLIOGRAPHY: List the books which have been thoroughly read and which relate to the course for which
				you are seeking credit and attach it to the portfolio package as Attachment D. Include each book's title,
				author, publisher, copyright date and brief description. You may be required to take a test on the book(s) if
				credit is to be awarded.</li>
				
				<li>EFFECTIVE MINISTRY EXPERIENCE: Document any effective ministry experience that you have had
				which would point to a mastery of the particular area of ministerial training for which you seeking credit.
				Attach your list of effective ministry experience as Attachment E to the Portfolio package.</li>
				</ul>			
				<p>List Courses you are requesting credit for</p>
				<p><textarea cols="500" rows="5" name="credit_courses"></textarea></p>
			</div>
						

			<p>Application processing Fee of $50.00 USD - application will not be processed until fee is received.</p>

			<p>By Clicking Submit, I certify that my answers to all questions in this application are complete and accurate.</p>

			<div class="buttonrow">
				<input type="submit" value="Save" class="button" />
		
				<input type="button" value="Discard" class="button" />
			</div>
	
		</form>
	</div>
</div>)};

export default Application;